import React, {
  useContext, createContext, useEffect, useState,
} from 'react';
import { PropTypes } from 'prop-types';

const initialState = [{
  name: 'Não Encontrado',
  dataNascimento: 'Não Encontrado',
  cns: 'Não Encontrado',
  cpf: 'Não Encontrado',
  genero: 'Não Encontrado',
}];

const SearchPageContext = createContext(
  initialState,
);

export function SearchPageContextProvider({ children }) {
  const [searchState, setSearchState] = useState(initialState);
  const ret = [{
    name: 'teste',
    dataNascimento: 'teste',
    cns: 'teste',
    cpf: 'teste',
    genero: 'teste',
  }, {
    name: 'teste2',
    dataNascimento: 'teste2',
    cns: 'teste2',
    cpf: 'teste2',
    genero: 'teste2',
  }, {
    name: 'teste3',
    dataNascimento: 'teste3',
    cns: 'teste3',
    cpf: 'teste3',
    genero: 'teste3',
  }, {
    name: 'teste4',
    dataNascimento: 'teste4',
    cns: 'teste4',
    cpf: 'teste4',
    genero: 'teste4',
  }];
  useEffect(() => {
    const teste = ret;
    setSearchState(teste);
  }, []);
  return (
    <SearchPageContext.Provider value={searchState}>
      {children}
    </SearchPageContext.Provider>
  );
}

export function useSearchPageContext() {
  return useContext(SearchPageContext);
}

SearchPageContextProvider.propTypes = {
  children: PropTypes.element.isRequired,
};
